import styled from 'styled-components';

import { getNotificationVisual } from 'constants/notificationTypes';

// The inbox row's kind chip (NotificationRow), extracted for the toast: same
// getNotificationVisual map, same 24px chip / 12px glyph geometry, so a kind's toast
// and its row are visually 1:1.
export default function NotificationKindChip({ kind, tone }: { kind: string; tone?: string | null }) {
  const { Icon, color, background } = getNotificationVisual(kind, tone);

  return (
    <Chip style={{ backgroundColor: background }}>
      <Icon width={12} height={12} color={color} />
    </Chip>
  );
}

const Chip = styled.div`
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
`;
